import React, { FC } from 'react';
import { Typography } from '@fullstory/components';
import { NoResultsContainer } from './NoResultsContainer';
import { ResourceListResourceType } from '../ResourceList';
import { intl } from '@fullstory/intl';
export interface NoMatchStateProps {
  resourceType: ResourceListResourceType;
}

const noMatchStateMessages: { [key in ResourceListResourceType]: { text: string } } = {
  Alert: {
    text: intl.formatMessage({
      defaultMessage: 'No Alerts match the current search.',
      id: 'PC6yYS',
    }),
  },
  Dashboard: {
    text: intl.formatMessage({
      defaultMessage: 'No Dashboards match the current search.',
      id: 'Agj3m4',
    }),
  },
  Funnel: {
    text: intl.formatMessage({
      defaultMessage: 'No Funnels match the current search.',
      id: 'Wlm/Vq',
    }),
  },
  Heatmap: {
    text: intl.formatMessage({
      defaultMessage: 'No Heatmaps match the current search.',
      id: 'uN/odi',
    }),
  },
  Journey: {
    text: intl.formatMessage({
      defaultMessage: 'No Journeys match the current search.',
      id: 'PsLE/q',
    }),
  },
  Metric: {
    text: intl.formatMessage({
      defaultMessage: 'No Metrics match the current search.',
      id: '0hr1Ox',
    }),
  },
  Page: {
    text: intl.formatMessage({
      defaultMessage: 'No Pages match the current search.',
      id: 'Fk/XAN',
    }),
  },
  Segment: {
    text: intl.formatMessage({
      defaultMessage: 'No Segments match the current search.',
      id: 'y1sbf8',
    }),
  },
  Retention: {
    text: intl.formatMessage({
      defaultMessage: 'No Retention matches the current search.',
      id: 'q9qeOw',
    }),
  },
  Space: {
    text: intl.formatMessage({
      defaultMessage: 'No Space matches the current search.',
      id: '6Ek44l',
    }),
  },
};

export const NoMatchState: FC<NoMatchStateProps> = ({ resourceType }) => (
  <NoResultsContainer data-component="NoMatchState" height={100}>
    <Typography variant="body2">{noMatchStateMessages[resourceType].text}</Typography>
  </NoResultsContainer>
);
